export default __webpack_public_path__ + "static/media/payment-info-2x.2fae5d2c.png";